import GroupIcon from "@mui/icons-material/Group";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import type { ReactNode } from "react";

import type { ModuleType } from "Infrastructure/Api/Api";
import { colors } from "Infrastructure/Themes/Colors";

interface ModuleTypeConfig {
  icon: ReactNode;
  color: string;
}

const c = colors();

export const MODULE_TYPE_CONFIG: Record<ModuleType, ModuleTypeConfig> = {
  SingleVoiceSpot: { icon: <RecordVoiceOverIcon />, color: c.InfoMain },
  MultiVoiceSpot: { icon: <GroupIcon />, color: c.InfoMain },
};
